import React, {Component} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input, FormText} from 'reactstrap';
import {ChannelLogo} from "../../channels/ChannelLogo";
import {GoogleLinkComponent} from "../link_acocunts/GoogleLinkt";
import {FacebookLinkComponent} from "../link_acocunts/FacebookLink";
import {TikTokLinkComponent} from "../link_acocunts/TiktokLink";
import {LinkedinLinkComponent} from "../link_acocunts/LinkedinLink";
import {GA4LinkComponent} from "../link_acocunts/GA4Link";
import {
    GOOGLE_CHANNEL, FACEBOOK_CHANNEL, TIKTOK_CHANNEL, LINKEDIN_CHANNEL, ANALYTICS_CHANNEL
} from "../../channels/channels";
import { withTranslation } from 'react-i18next';


const CHANNEL_DISPLAY_NAMES = {
    [GOOGLE_CHANNEL]: 'Google Ads',
    [FACEBOOK_CHANNEL]: 'Meta Ads',
    [TIKTOK_CHANNEL]: 'TikTok Ads',
    [LINKEDIN_CHANNEL]: 'LinkedIn Ads',
    [ANALYTICS_CHANNEL]: 'GA4',
};

class AddCredentialModalClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            name: '',
        };
        this.toggle = this.toggle.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleBeforeConnect = this.handleBeforeConnect.bind(this);
    }

    toggle() {
        this.setState(prev => ({
            modal: !prev.modal,
            name: prev.modal ? '' : prev.name,
        }));
    }

    handleNameChange(e) {
        this.setState({name: e.target.value});
    }

    handleBeforeConnect() {
        if (this.state.name.trim()) {
            localStorage.setItem('pending_credential_label', this.state.name.trim());
        }
    }

    renderLinkComponent() {
        const {channel} = this.props;
        const noop = () => {};
        switch (channel) {
            case GOOGLE_CHANNEL:
                return <GoogleLinkComponent hasConnection={false} onConnectionDeleted={noop}/>;
            case FACEBOOK_CHANNEL:
                return <FacebookLinkComponent hasConnection={false} onConnectionDeleted={noop}/>;
            case TIKTOK_CHANNEL:
                return <TikTokLinkComponent hasConnection={false} onConnectionDeleted={noop}/>;
            case LINKEDIN_CHANNEL:
                return <LinkedinLinkComponent hasConnection={false} onConnectionDeleted={noop}/>;
            case ANALYTICS_CHANNEL:
                return <GA4LinkComponent hasConnection={false} onConnectionDeleted={noop}/>;
            default:
                return null;
        }
    }

    render() {
        const {channel, t} = this.props;
        const {name} = this.state;
        const displayName = CHANNEL_DISPLAY_NAMES[channel] || channel;
        const isNameValid = name.trim().length > 0;

        return (
            <Modal isOpen={this.state.modal} toggle={this.toggle} backdrop="static">
                <ModalHeader toggle={this.toggle}>
                    <ChannelLogo channel={channel}/>&nbsp;{t('add_credential_modal.title', {channel: displayName})}
                </ModalHeader>
                <ModalBody style={{padding: '1.5em'}}>
                    <FormGroup>
                        <Label>{t('add_credential_modal.name_label')}</Label>
                        <Input
                            type="text"
                            value={name}
                            onChange={this.handleNameChange}
                            placeholder={t('add_credential_modal.name_placeholder')}
                        />
                        <FormText>{t('add_credential_modal.name_hint')}</FormText>
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <div
                        onClickCapture={this.handleBeforeConnect}
                        style={{
                            pointerEvents: isNameValid ? 'auto' : 'none',
                            opacity: isNameValid ? 1 : 0.5,
                        }}
                    >
                        {this.renderLinkComponent()}
                    </div>
                </ModalFooter>
            </Modal>
        );
    }
}

export const AddCredentialModal = withTranslation()(AddCredentialModalClass);
export default AddCredentialModal;
